import { connect } from "react-redux"
import { selectFrameClip, setFrameLoad, setLoadedFrameCount, setPropertyWindow } from "../../actions";
import FramesComponent from "../../components/Frame/FramesComponent"

const mapStateToProps = (state, ownProps) => ({
    zoomFactor: state.localStore.get("zoomFactor"),
    propertyWindow: state.localStore.get("propertyWindow"),
    transformStatus: state.localStore.get("transformStatus"),
    clipCount: state.localStore.get("clipCount"),
    // isPreview : state.localStore.get('isPreview'),
    // isFullScreen : state.localStore.get("isFullScreen"),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    // selectFrameClip: (data) => dispatch(selectFrameClip(data)),
    // setPropertyWindow: (data) => dispatch(setPropertyWindow(data)),
    // setFrameLoad: (data) => dispatch(setFrameLoad(data)),
    // setLoadedFrameCount: (data) => dispatch(setLoadedFrameCount(data)),
});

const Frames = connect(
    mapStateToProps,
    mapDispatchToProps
)(FramesComponent)

export default Frames;


// WEBPACK FOOTER //
// ./src/containers/Frame/Frames.js